import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
  PrivacyPolicyDocument,
  PrivacyPolicyQuery,
  PrivacyPolicyQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: PrivacyPolicyDocument });
  await client.query({ query: FooterDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  const { data: privacyPolicy } = await client.query<
    PrivacyPolicyQuery,
    PrivacyPolicyQueryVariables
  >({
    query: PrivacyPolicyDocument,
  });

  return addApolloState(client, {
    props: {
      footerData,
      headerData,
      privacyPolicy,
    },
  });
};

const PrivacyPolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, privacyPolicy }) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Seo seo={privacyPolicy.privacyPolicy?.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={privacyPolicy.privacyPolicy?.data?.attributes?.policies}
    />
  </Layout>
);

export default PrivacyPolicy;
